import { useQuery } from "react-query"
import { get_company_detail } from "../../services/approvals";


const useCompanyDetail = (id) => {
    return useQuery('get_company_detail', ()=>get_company_detail(id))
}

export default useCompanyDetail;